var trend = function() {
    var instance = {};

    //Set scope variable to init dbtable with options, columns etc
    instance.init = function(scope, componentKey, component) {
        //initalise component properties
        scope[componentKey] = {};
        scope[componentKey].instance = {};
        scope[componentKey].data = component.init_config;
    };
    instance.update = function(scope, componentKey, resultComponentVal) {
        //initalise component properties
        scope[componentKey] = {};
        scope[componentKey].instance = {};
        var config_data = resultComponentVal.config;

        //set the datalabels formatter function
        var datalabels_formatter = function() {
            var color = this.series.color;
            var temp_compare = typeof this.point.compare != 'undefined' ? this.point.compare : '';
            return ("<div class='trendChartDataLabelContainer' style='background-color:#FFF;border:1px solid " + color + ";'><span class='trendDataLabel'>" + this.y + "" + temp_compare + "</span><span class='trendDataLabel subLabel'>" + (this.point.sample_size != null ? "n=" + this.point.sample_size : "") + "</span></div>");
        }
        config_data.options.plotOptions.series.dataLabels.formatter = datalabels_formatter;

        //prevent legend click and enable toggling of the datalabels
        config_data.options.plotOptions.series.events = {
            "legendItemClick": function() {
                var datalabels_visible = this.options.dataLabels.enabled;
                if (datalabels_visible) {
                    $.each(this.points, function(pIndex, point) {
                        point.update({
                            dataLabels: {
                                enabled: false
                            }
                        });
                    });
                } else {
                    $.each(this.points, function(pIndex, point) {
                        point.update({
                            dataLabels: {
                                enabled: true
                            }
                        });
                    });
                }
                this.options.dataLabels.enabled = !datalabels_visible;
                return false; // <== returning false will cancel the default action
            }
        };

        config_data.options.plotOptions.series.point.events = {
            "mouseOver": function(event) {
                var xIndex = this.index;
                var plotLine = {
                    'id': 'current-plot-line',
                    'color': '#000',
                    'dashStyle': 'solid',
                    'value': xIndex,
                    'width': 1.5,
                    'label': ''
                }
                scope[componentKey].instance.xAxis[0].addPlotLine(plotLine, true);
            },
            "mouseOut": function() {
                var chart = this;
                scope[componentKey].instance.xAxis[0].removePlotLine('current-plot-line');
            }
        }

        config_data.options.plotOptions.line.events = {
            "mouseOut": function() {
                var chart = this;
                scope[componentKey].instance.xAxis[0].removePlotLine('current-plot-line');
            }
        }

        //set event for highlighting the series while hovering the legend
        var chartLineHoverEventHandler = function(chart, state, index) {
            switch (state) {
                case 'over':
                    // mouseover
                    if (chart != undefined) {
                        for (var i = 0; i < chart.series.length; i++) {
                            if (chart.series[i] != undefined && chart.series[i] != '' && chart.series[i].graph != undefined) {
                                chart.series[i].graph.attr('opacity', '0.1');
                            }
                        }
                        // this series
                        if (chart.series[index] != undefined && chart.series[index] != '' && chart.series[index].graph != undefined) {
                            chart.series[index].graph.attr('opacity', '1');
                            // show data labels
                            var series = chart.series[index];
                            $.each(series.points, function(pIndex, point) {
                                point.update({
                                    dataLabels: {
                                        enabled: true
                                    }
                                });
                            });
                        }
                    }
                    break;
                case 'out':
                    // mouseout
                    if (chart != undefined) {
                        for (var j = 0; j < chart.series.length; j++) {
                            if (chart.series[j] != undefined && chart.series[j] != '' && chart.series[j].graph != undefined) {
                                chart.series[j].graph.attr('opacity', '1');
                            }
                        }
                        // this series
                        if (chart.series[index] != undefined) {
                            // hide data labels
                            var series = chart.series[index];
                            if (series.options.dataLabels.enabled != true) {
                                $.each(series.points, function(pIndex, point) {
                                    point.update({
                                        dataLabels: {
                                            enabled: false
                                        }
                                    });
                                });
                            }

                        }
                    }
                    break;
            }
        }

        var chart_events = {
            redraw: function() {
                var chart = this,
                    legend = chart.legend;

                //Check if legends are enabled & the items exist
                if(typeof legend != 'undefined' && typeof legend.allItems != 'undefined'){
                    for (var index = 0, len = legend.allItems.length; index < len; index++) {
                        (function(index) {
                            var item = legend.allItems[index].legendItem;

                            item.on('mouseover', function(e) {
                                //show tooltip
                                chartLineHoverEventHandler(chart, 'over', index);
                            }).on('mouseout', function(e) {
                                //hide tooltip
                                chartLineHoverEventHandler(chart, 'out', index);
                            });
                        })(index);
                    }
                }
            },
            mouseOut: function() {
                var chart = this;
                chart.xAxis[0].removePlotLine('current-plot-line');
            }
        };
        config_data.options.chart.events = chart_events;

        //tooltip formatter
        config_data.options.tooltip.formatter = function() {

            var toolTipText = '<h4 style="padding-bottom:4px;">' + this.x + '</h4>';
            var xIndex = null;

            //get all points at this X-Axis mark to create tool tip text
            $.each(this.points, function(i, point) {
                var temp_compare = typeof point.point.options.compare != 'undefined' ? point.point.options.compare : '';
                toolTipText += '<span style="color:' + point.series.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y + '</b>' + temp_compare + '<br/>';
                if (xIndex === null && typeof(point.point) != 'undefined' && typeof(point.point.index) != 'undefined') {
                    xIndex = point.point.index;
                }
            });

            //add plot line at this X-Axis mark
            if (xIndex !== null) {
                //remove the current plot line
                scope[componentKey].instance.xAxis[0].removePlotLine('current-plot-line');

                //add plot line
                var plotLine = {
                    'id': 'current-plot-line',
                    'color': '#000',
                    'dashStyle': 'solid',
                    'value': xIndex,
                    'width': 1.5,
                    'label': ''
                }
                scope[componentKey].instance.xAxis[0].addPlotLine(plotLine, true);
            }

            return toolTipText;
        }

        scope[componentKey].data = config_data;

        setTimeout(function() {
            scope[componentKey].instance = angular.element(
                document.getElementById(componentKey)
            ).highcharts();
            scope[componentKey].instance.reflow();
            scope.$broadcast('highchartsng.reflow');
        }, 500);

        scope.$broadcast('highchartsng.reflow');
    };

    return instance;
};
